function initializeFilterTooltips() {
  const result = Array.from(document.querySelectorAll(".filter-tooltip"));

  result.forEach((el) => {
    var parent = el.closest("details-disclosure");
    parent.classList.add("filter-tooltip--enabled");
    var maskButton = parent.querySelector(".filter__tooltip-mask");

    maskButton.addEventListener("click", () => {
      const modal = document.getElementById(el.dataset?.id);
      if (modal) {
        const closeModal = () => {
          modal.style.display = "none";
          modal.removeEventListener("click", handleClickOutside);
          document.removeEventListener("keydown", handleEscape);
        };
        const handleClickOutside = (event) => {
          if (event.target.closest("button") || !event.target.closest(".product-tooltip-modal__wrapper")) {
            closeModal();
          }
        };
        const handleEscape = (event) => {
          if (event.key === "Escape") {
            closeModal();
          }
        };
        modal.style.display = "flex";
        modal.addEventListener("click", handleClickOutside);
        document.addEventListener("keydown", handleEscape);
      }
    });
  });
}
document.addEventListener("DOMContentLoaded", () => {
  initializeFilterTooltips();
});

document.addEventListener("on:facet-filters:updated", function () {
  initializeFilterTooltips();
});
